<template>
  <div>
    <div class="slider-container">
  <div class="slider">
    <div class="slide">Slide 1</div>
    <div class="slide">Slide 2</div>
    <div class="slide">Slide 3</div>
  </div>
</div>

  </div>
</template>

<script>
import MyComponent from './MyComponent.vue'

export default {
  components: {
    MyComponent
  },
  data () {
    return {
      messageFromParent: 'Hello from parent!',
      icon: 'mdi-email',
      color: '#C4D0FB',
      padding: '0 10px 0 0'
    }
  }
}
</script>
<style>
.slider-container {
  overflow: hidden; /* Hide overflow to create the sliding effect */
  width: 300px; /* Set the width of the slider container */
  height: 200px; /* Set the height of the slider container */
}

.slider {
  display: flex;
  width: 900px; /* Total width of all slides combined (3 * 300px) */
  animation: slide 10s infinite; /* Apply the slide animation */
}

.slide {
  flex: 0 0 300px; /* Set the width of each slide */
  height: 100%; /* Set the height of each slide */
  background-color: lightblue;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
}

@keyframes slide {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-300px); /* Slide each slide to the left by 300px */
  }
}
</style>



// WEBPACK FOOTER //
// src/components/V2LOYALTY_REDESIGN/form.vue